module.exports = __webpack_public_path__ + "img/icon_arrow_left_white.e1c9402c.svg";